import React, { Component } from 'react';
import { RichText } from 'prismic-reactjs';
import './style.css';

export class Footer extends Component {
    render() {
        let phone;
        let address;
        let email;

        if(typeof this.props.content !== 'undefined') {
            phone = RichText.asText(this.props.content.data.phone);
            address = RichText.render(this.props.content.data.address);
            email = RichText.asText(this.props.content.data.email);
        }

        return (
            <footer className="footer">
                <address>
                    <ul className="contact-list">
                        <li className="contact-list__phone"><a href="tel:+32473335106">{ phone }</a></li>
                        <li className="contact-list__address"> <a href="https://www.google.be/maps/place/Erudis+Consulting/@50.6882959,4.4030483,15z/data=!4m5!3m4!1s0x0:0x95a35092c9951e48!8m2!3d50.6882959!4d4.4030483" target="_blank">{ address }</a></li>
                        <li className="contact-list__mail"><a href={'mailto:'+email}>{ email }</a></li>
                    </ul>
                </address>
            </footer>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer/index.js